import { POOLS } from "../types";

export const PoolsReducer = (state = [], action) => {
	const { type, payload } = action;

	switch (type) {
		case POOLS: {
			const { data } = payload;
			state = [];
			return data;
		}
		default: {
			return state;
		}
	}
};
